/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CreateCustomEventMetricRequestBody = {
    properties: {
        name: {
    type: 'string',
    isRequired: true,
},
        description: {
    type: 'string',
},
        isLeaderOrderDescending: {
    type: 'boolean',
    isRequired: true,
},
    },
};